import React, { useState } from 'react'
import styled from 'styled-components/macro'
import { Helmet } from 'react-helmet'
import { Redirect, useHistory } from 'react-router-dom'

import FirebaseAuth from 'views/_util/FirebaseAuth'
import { LoadingPage } from 'styles/loading'
import ErrorPage from 'views/_components/ErrorPage'
import { Label, Input } from 'styles/forms'
import { Button } from 'styles/buttons'
import logOut from 'actions/logOut'

const AdminLayout = ({
  title,
  children,
}) => {

  const history = useHistory()

  const [userId, setUserId]         = useState('')
  const [userEmail, setUserEmail]   = useState('')
  const [orgId, setOrgId]           = useState('')
  const [boardId, setBoardId]       = useState('')
  const [boardOrgId, setBoardOrgId] = useState('')

  return <FirebaseAuth>
    { ({isLoading, error, auth}) => {
      if (isLoading) {
        return <LoadingPage>Loading</LoadingPage>
      }
      if (error) {
        return <ErrorPage error={error} />
      }

      if (!auth || auth.email !== 'sam@directedworks.com') {
        return <Redirect
          to={{
            pathname: "/login",
            search: `?redirectTo=${encodeURIComponent(window.location.href)}`,
            state: { message: "You have to log in as an admin first"}
          }}
        />
      }

      return <AdminLayoutWrapper>
        <Helmet>
          <title>{title || 'Account'} :: ADMIN</title>
        </Helmet>

        <AdminSidebar>
          <AdminLogo href="/admin">Shuffleboard Admin</AdminLogo>
          
          <hr />

          <form onSubmit={() => {
            if (userId) {
              history.push(`/admin/user?userId=${userId}`)
            } else if (userEmail) {
              history.push(`/admin/user?userEmail=${userEmail}`)
            } else {
              alert('Please enter either a user ID or a user email')
            }
          }}>
            <Label>User Email</Label>
            <Input
              name="userEmail"
              maxLength={1000}
              placeholder="bob@acme.com"
              wide="wide"
              value={userEmail}
              onChange={event => setUserEmail(event.target.value)}
              small
            />
            <Label>Or user ID</Label>
            <Input
              name="userId"
              maxLength={1000}
              placeholder="abc123"
              wide="wide"
              value={userId}
              onChange={event => setUserId(event.target.value)}
              small
            />
            <Button
              type="submit"
              small
              wide
              secondary
            >
              Get user
            </Button>
          </form>

          <hr />

          <form onSubmit={() => history.push(`/admin/org?orgId=${orgId}`)}>
            <Label>Org ID</Label>
            <Input
              name="orgId"
              maxLength={1000}
              placeholder="abc123"
              wide="wide"
              value={orgId}
              onChange={event => setOrgId(event.target.value)}
              required
              small
            />
            <Button
              type="submit"
              small
              wide
              secondary
            >
              Get org
            </Button>
          </form>

          <hr />

          <form onSubmit={() => history.push(`/admin/board?orgId=${boardOrgId}&boardId=${boardId}`)}>
            <Label>Board org</Label>
            <Input
              name="boardOrgId"
              maxLength={1000}
              placeholder="abc123"
              wide="wide"
              value={boardOrgId}
              onChange={event => setBoardOrgId(event.target.value)}
              required
              small
            />
            <Label>and board ID</Label>
            <Input
              name="boardId"
              maxLength={1000}
              placeholder="abc123"
              wide="wide"
              value={boardId}
              onChange={event => setBoardId(event.target.value)}
              required
              small
            />
            <Button
              type="submit"
              small
              wide
              secondary
            >
              Get board
            </Button>
          </form>

          <hr />

          <p>Signed in as {auth.email}</p>
          <button onClick={ () => logOut().then( () => history.push('/login')) }>
            Log out
          </button>

        </AdminSidebar>

        <AdminMain>
          {children}
        </AdminMain>

      </AdminLayoutWrapper>
      
    }}
  </FirebaseAuth>
  
}

const AdminLayoutWrapper = styled.div`
  display: grid;
  grid-template-columns: 18rem auto;
  grid-column-gap: 3rem;
  height: auto !important;
  min-height: 100%;
`
const AdminSidebar = styled.div`
  padding: 2rem;
  border-right: 1px solid var(--hairline);

  @media(max-width: 599px) {
    padding: 1rem;
  }
`
const AdminMain = styled.div`
  margin: 0 auto;
  padding: 2rem;
  width: 50rem;
  max-width: 100%;

  @media(max-width: 599px) {
    padding: 1rem;
  }

  h2 {
    border-bottom: 2px solid var(--hairline);
    padding-bottom: .25rem;
  }
`
const AdminLogo = styled.a`
  font-family: monospace;
  color: hsl(120, 90%, 70%);
  background: #333;
  padding: 1px 5px;
  text-align: center;
`

export default AdminLayout
